import React from 'react';
import { Styles } from '../styles/courseTag.js';

const CourseTag = ({
    tags = [],
    loading,
    selectedTags = [],
    onToggleTag = () => {}
}) => {
    const displayTags = React.useMemo(() => {
        const existing = new Set(tags);
        selectedTags.forEach((tag) => tag && existing.add(tag));
        return Array.from(existing);
    }, [tags, selectedTags]);

    return (
        <Styles>
            <div className="course-tag">
                <h5>Course Tag</h5>
                {loading ? (
                    <p className="loading text-muted">Loading tags…</p>
                ) : displayTags.length === 0 ? (
                    <p className="empty text-muted">No tags available.</p>
                ) : (
                    <div className="tag-box">
                        {displayTags.map((tag) => {
                            const isActive = selectedTags.includes(tag);
                            return (
                                <button
                                    type="button"
                                    key={tag}
                                    className={isActive ? 'active' : ''}
                                    onClick={() => onToggleTag(tag)}
                                >
                                    {tag}
                                </button>
                            );
                        })}
                    </div>
                )}
            </div>
        </Styles>
    );
};

export default CourseTag;
